import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';

import { TvPlanContext } from '../../contexts/tvplancontext';
import TvService from '../TvService';

import './index.css';


export default function TvServiceInfoModal(props) {
    const ctx = useContext(TvPlanContext);
    const { t } = useTranslation('tvplan');
    const onClose = () => ctx.hideServiceInfo();

    return (
        <Modal
            open={props.visible}
            title={t('Service Info')}
            onCancel={onClose}
            cancelButtonProps={{ style: { display: 'none' } }}
            onOk={onClose}
        >
            {props.code}<br />
            <TvService code={props.code} onClick={null} />
        </Modal>
    );
}
